// extracted by mini-css-extract-plugin
export default {"root":"styles-scoped__root--F99HM","header":"styles-scoped__header--lvHyM"};